import EstimateItem from "./estimate-item";
import { CONSUMPTION_TAX_RATE } from "@/preferences";

export default class Estimate {
  id: number = 0;
  title: string = "";
  attention: string = "";
  mention: string = "";
  projectId: number = 0;
  projectName: string = "";
  projectClientName: string = "";
  staffName: string = "";
  status: string = "created";
  items: EstimateItem[] = [];
  total: number = 0;
  subtotal: number = 0;
  tax: number = 0;
  taxRate: number = CONSUMPTION_TAX_RATE;
  loss: number = 0;
  lossRate: number = 0;
  lossTotal: number = 0;
  printsExcludeTax: boolean = false;
  dateOfIssue: string = "";
  deadline: string = "";
  profitRate: number = 0;
  estimateNumber?: string = "";
  hasProjectId?: boolean = false;
  projectContractDate?: string = "";
  paymentMethod: string = "";
  estimatePaymentMethods: string[] = [];

  constructor(projectId?: any) {
    if (this.projectId) {
      this.hasProjectId = !this.hasProjectId;
    }

    this.projectId = projectId;
  }
}
